import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FullRow, Row, Col } from '../../framework/Grid'
import SelectedAttrs from '../SelectedAttrs'
import { getMapVectorOptions } from '../../../utils/utility'

import { withGoogleMap, GoogleMap, Circle, Polygon, Rectangle } from "react-google-maps"
import { PieChart, Pie, Tooltip, Cell } from 'recharts'
import { map, isEmpty } from 'lodash'
import "./SegmentAttribute.css"
import { splitNumber } from '../../../utils/utility'

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
const google = window.google
const CustomTooltip = React.createClass({
	propTypes: {
		datas: PropTypes.array
	},

	render() {
		const { active } = this.props;

		if (active) {
			const { datas, payload } = this.props;
			const data = datas.find(function(obj){ return obj.name === payload[0].name})
			const total = datas.reduce(function(sum, obj){return sum + obj.value }, 0)
			const percent = data ? data.value / total : 0
			
			return (

				<div className="bg-white pl-20 pr-20 pt-10 pb-10" style={{ width: "420px" }}>
					<FullRow className="no-padding-left no-padding-bottom no-padding-top font-12em text-bold">{data.name}</FullRow>
					<FullRow className="no-padding-left no-padding-bottom no-padding-top text-black">
						{`${(percent * 100).toFixed(2)}%`}
					</FullRow>
					<FullRow className="no-padding-left no-padding-bottom">Reach by Channel</FullRow>
					<Row className="no-padding no-padding-top">
						<Col xs="4" sm="4" md="4" lg="4">
							<p><i className="icon-envelope" style={{ fontSize: '1.2em' }} /><span className="ml-10 text-default text-bold">{splitNumber(data.email+'')()}</span></p>
						</Col>
						<Col xs="4" sm="4" md="4" lg="4" style={{paddingRight: 0}}>
							<p><i className="icon-share3" style={{ fontSize: '1.2em' }} /><span className="ml-10 text-default text-bold">{splitNumber(data.social+'')()}</span></p>
						</Col>
						<Col xs="4" sm="4" md="4" lg="4">
							<p className="pull-left"><i className="icon-display4" style={{ fontSize: '1.2em' }} /><span className="ml-10 text-default text-bold">{splitNumber(data.display+'')()}</span></p>
						</Col>
					</Row>
				</div>
			);
		}

		return null;
	}
});

class SegmentAttribute extends Component {
	componentWillMount() {
		this.state = {
			viewMode: "chart"
		}
	}

	handleMapMounted(map) {
		this._map = map
		if (this._map && this._vector){
			try{
				this._map.fitBounds(this._vector.getBounds())
			}catch(ex){

			}
		}
	}

	renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
		const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
		const RADIAN = Math.PI / 180;
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);

		return (
			<text x={x} y={y} fill="#FFFFFF" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
				{`${(percent * 100).toFixed(0)}%`}
			</text>
		);
	};
	getContent(data) {
		if (this.state.viewMode === "chart") {
			const doms = []
			map(data, (item, key) => {
				if (key > 100) {
					const attrLabel = item.label
					const attrTotal = item.total
					let pairValueCount = 0
					const subItems = []
					map(item, (subItem, itemKey) => {
						if ((typeof subItem === "object") && (subItem !== null)) {
							pairValueCount += 1
							subItems.push({
								name: subItem.label, value: subItem.total,
								email: subItem.email,
								display: subItem.display.toString(),
								social: subItem.social
							})
						}
					})
					const dom = <div key={"pair-values-panel-" + key} className="panel panel-flat bg-grey-300 segment-attr-panel" style={{ backgroundColor: "#CCC", color: "#777" }}>
						<div className="panel-heading right-margin " style={{ padding: "0.5em 1em" }}>
							{pairValueCount > 1 ? `${attrLabel} (${pairValueCount})` : attrLabel}
						</div>
						<div className="panel-body border-top right-margin no-padding-bottom " style={{ paddingRight: "3em", borderColor: "#E3E3D3" }}>
							<Row style={{padding: 0}}>
								<Col xs="4" sm="4" md="4" lg="4" style={{paddingTop: '20px', paddingLeft:"50px"}}>
									{
										(pairValueCount > 1) && (
											<PieChart width={200} height={150}>
												<Pie dataKey="value" data={subItems} cx={70} cy={70}
													innerRadius={30} outerRadius={60} fill="#26A69A">
													{
														subItems.map((entry, index) => <Cell key={`pie-cell-${index}`} fill={COLORS[index % COLORS.length]} />)
													}
												</Pie>
												<Tooltip content={<CustomTooltip datas={subItems} />} />
											</PieChart>
										)
									}
								</Col>
								<Col xs="8" sm="8" md="8" lg="8" className="pt-20">
									{
										map(subItems, (subItem, index) => {
											return (<Row key={"pair-values-row-div-" + index} className={"no-margin-bottom pt-10"} style={{padding: 0}}>
												<Col xs='8' md='8' sm='8' lg='8' className="no-padding-right no-padding-left" style={{ overflow: "hidden" }}>
													<div style={{ float: "left" }}>
														{pairValueCount > 1 ? <span className="span-legend" style={{ background: COLORS[index % COLORS.length] }} >&nbsp;</span> : ""}{subItem.name}&nbsp;&nbsp;&nbsp;
													</div>
													<div style={{ marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' }}>&nbsp;</div>
												</Col>
												<Col xs="4" md="4" sm="4" lg="4" className="text-right no-padding-right no-padding-left" style={{ overflow: "hidden" }} >
													<div style={{ float: "right" }}>&nbsp;&nbsp;&nbsp;
													{splitNumber(subItem.value+'')()}
													</div>
													<div style={{ marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' }}>&nbsp;</div>
												</Col>
											</Row>
											)
										})
									}
									<Row style={{paddingLeft:0, paddingRight: 0}}>
										<Col xs="6" sm="6" md="6" lg="6" className="no-padding-left text-black "><strong style={{color:"black"}}>Total Count</strong></Col>
										<Col xs="6" sm="6" md="6" lg="6" className="text-right no-padding-right text-black"><strong style={{color:"black"}}>{splitNumber(attrTotal+'')()}</strong></Col>
									</Row>
								</Col>
							</Row>
						</div>
					</div>
					doms.push(dom)
				}
			})

			if (this.props.rawData) {
				const raw = JSON.parse(this.props.rawData)
				if ((raw.selected_city.length > 0) || (raw.selected_state.length > 0) || (raw.zipcode.length > 0)) {
					const city_states = []
					const zipcodes = []
					let total_count = 0
					map(raw.selected_state, (state) => {
						city_states.push({ name: state.label, value: state.total, email: state.email, social: state.social, display: state.display })
						total_count += state.total
					})
					map(raw.selected_city, (city) => {
						city_states.push({ name: city.value + ", " + city.state, value: city.total, email: city.email, social: city.social, display: city.display })
						total_count += city.total
					})
					map(raw.zipcode, (zipcode) => {
						zipcodes.push({ name: zipcode.zipcode, value: zipcode.total, email: zipcode.email, social: zipcode.social, display: zipcode.display })
						total_count += zipcode.total
					})
					if (city_states.length > 0) {
						const row = <div key="city-state-panel" className="panel panel-flat bg-grey-300 city-state-panel" style={{ backgroundColor: "#CCC", color: "#777" }}>
							<div className="panel-heading text-uppercase right-margin " style={{ padding: "0.5em 1em" }}>
								{city_states.length > 1 ? "US STATE/CITY (" + city_states.length + ")" : "US STATE/CITY"}
							</div>
							<div className="panel-body border-top right-margin  no-padding-bottom " style={{ paddingRight: "3em", borderColor: "#E3E3D3" }}>
								<Row className="no-padding-bottom" style={{padding: 0}}>
									<Col xs="4" sm="4" md="4" lg="4" style={{ height: "180px" }}>
										{
											(city_states.length > 1) && (
												<PieChart width={200} height={150}>
													<Pie dataKey="value" data={city_states} cx={70} cy={70}
														innerRadius={30} outerRadius={60} fill="#26A69A">
														{
															city_states.map((entry, index) => <Cell key={`citystate-pie-cell-${index}`} fill={COLORS[index % COLORS.length]} />)
														}
													</Pie>
													<Tooltip content={<CustomTooltip datas={city_states} />} />
												</PieChart>
											)
										}
									</Col>
									<Col xs="8" sm="8" md="8" lg="8" className="pt-20">
										{
											map(city_states, (subItem, index) => {
												return (<Row key={"city-state-row-div-" + index} className={"no-margin-bottom pt-10"} style={{padding: 0}}>
													<Col xs='8' md='8' sm='8' lg='8' className="no-padding-right no-padding-left" style={{ overflow: "hidden" }}>
														<div style={{ float: "left" }}>
															{city_states.length > 1 ? <span className="span-legend" style={{ background: COLORS[index % COLORS.length] }} >&nbsp;</span> : ""}{subItem.name}&nbsp;&nbsp;&nbsp;
													</div>
														<div style={{ marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' }}>&nbsp;</div>
													</Col>
													<Col xs="4" md="4" sm="4" lg="4" className="text-right no-padding-right no-padding-left" style={{ overflow: "hidden" }} >
														<div style={{ float: "right" }}>&nbsp;&nbsp;&nbsp;
													{splitNumber(subItem.value+'')()}
														</div>
														<div style={{ marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' }}>&nbsp;</div>
													</Col>
												</Row>
												)
											})
										}
										<Row className="no-padding-left no-padding-right">
											<Col xs="6" sm="6" md="6" lg="6" className="no-padding-left text-black"><strong style={{color:"black"}}>Total Count</strong></Col>
											<Col xs="6" sm="6" md="6" lg="6" className="text-right no-padding-right text-black"><strong style={{color:"black"}}>{splitNumber(total_count+'')()}</strong></Col>
										</Row>
									</Col>
								</Row>
							</div>
						</div>
						doms.unshift(row)
					}
					if (zipcodes.length > 0) {
						const row = <div key="zipcode-panel" className="panel panel-flat bg-grey-300 zipcode-panel" style={{ backgroundColor: "#CCC", color: "#777" }}>
							<div className="panel-heading text-uppercase right-margin " style={{ padding: "0.5em 1em" }}>
								{zipcodes.length > 1 ? "Zipcodes (" + zipcodes.length + ")" : "Zipcode"}
							</div>
							<div className="panel-body border-top right-margin  no-padding-bottom " style={{ paddingRight: "3em", borderColor: "#E3E3D3" }}>
								<Row className="no-padding-bottom" style={{padding: 0}}>
									<Col xs="4" sm="4" md="4" lg="4" style={{ height: "180px" }}>
										{
											(zipcodes.length > 1) && (
												<PieChart width={200} height={150}>
													<Pie dataKey="value" data={zipcodes} cx={70} cy={70}
														innerRadius={30} outerRadius={60} fill="#26A69A">
														{
															zipcodes.map((entry, index) => <Cell key={`citystate-pie-cell-${index}`} fill={COLORS[index % COLORS.length]} />)
														}
													</Pie>
													<Tooltip content={<CustomTooltip datas={zipcodes} />} />
												</PieChart>
											)
										}
									</Col>
									<Col xs="8" sm="8" md="8" lg="8" className="pt-20">
										{
											map(zipcodes, (subItem, index) => {
												return (<Row key={"city-state-row-div-" + index} className={"no-margin-bottom pt-10"} style={{padding: 0}}>
													<Col xs='8' md='8' sm='8' lg='8' className="no-padding-right no-padding-left" style={{ overflow: "hidden" }}>
														<div style={{ float: "left" }}>
															{city_states.length > 1 ? <span className="span-legend" style={{ background: COLORS[index % COLORS.length] }} >&nbsp;</span> : ""}{subItem.name}&nbsp;&nbsp;&nbsp;
													</div>
														<div style={{ marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' }}>&nbsp;</div>
													</Col>
													<Col xs="4" md="4" sm="4" lg="4" className="text-right no-padding-right no-padding-left" style={{ overflow: "hidden" }} >
														<div style={{ float: "right" }}>&nbsp;&nbsp;&nbsp;
													{splitNumber(subItem.value+'')()}
														</div>
														<div style={{ marginTop: "-10px", overflow: 'hidden', borderBottom: '1px #666 dashed' }}>&nbsp;</div>
													</Col>
												</Row>
												)
											})
										}
										<Row style={{paddingLeft: 0}}>
											<Col xs="6" sm="6" md="6" lg="6" className="no-padding-left text-black"><strong style={{color:"black"}}>Total Count</strong></Col>
											<Col xs="6" sm="6" md="6" lg="6" className="text-right no-padding-right text-black"><strong style={{color:"black"}}>{splitNumber(total_count+'')()}</strong></Col>
										</Row>
									</Col>
								</Row>
							</div>
						</div>
						doms.unshift(row)
					}

				}

				let PlottedRadiusMap = null

				if (!isEmpty(raw.plotted_values)) {
					const { radius, addressLabel, audienceCount, driveTime } = raw.plotted_values
					let geoText = ""
					if (addressLabel) {
						geoText = driveTime ? 'GEOGRAPHIC : Drive ' + driveTime + ' Hour(s) From ' + addressLabel.replace(", United States", "") :
							'GEOGRAPHIC : ' + radius + ' Mile(s) From ' + addressLabel.replace(", United States", "")
					} else {
						geoText = "GEOGRAPHIC : AREA SELECTED"
						let vector = null
						const plottedRadius = raw.plotted_values
						switch (plottedRadius.type) {
							case "circle":
								vector = <Circle ref={(elm) => this._vector = elm} center={plottedRadius.center} radius={plottedRadius.radius} options={getMapVectorOptions()} />
								break
							case "polygon":
								vector = <Polygon ref={(elm) => this._vector = elm} 
									path={typeof plottedRadius.path === "string" ? google.maps.geometry.encoding.decodePath(plottedRadius.path) : plottedRadius.path} 
									options={getMapVectorOptions()} />
								break
							case "rectangle":
							default:
								vector = <Rectangle ref={(elm) => this._vector = elm} bounds={plottedRadius.bounds} radius={plottedRadius.radius} options={getMapVectorOptions()} />
								break
						}
						if (vector) {
							PlottedRadiusMap = withGoogleMap(props => (
								<GoogleMap
									zoom={plottedRadius.zoom}
									center={plottedRadius.center}
									defaultOptions={{
										streetViewControl: false,
										mapTypeControl: false,
										zoomControl: false,
										scrollwheel: false,
										draggable: false
									}}
									ref={this.handleMapMounted.bind(this)}
								>
									{vector}
								</GoogleMap>
							));
						}

					}

					const row = <div key="geo-text-container" className="panel panel-flat bg-grey-300" style={{ backgroundColor: "#CCC", color: "#777" }}>
						<div className="panel-heading text-uppercase right-margin " style={{ padding: "0.5em 1em" }}>
							{geoText}
						</div>
						<div className="panel-body border-top right-margin  no-padding-bottom " style={{ paddingRight: "3em", borderColor: "#E3E3D3" }}>
							<Row className="no-padding-bottom" style={{padding: 0}}>
								<Col xs="4" sm="4" md="4" lg="4" className={PlottedRadiusMap && "google_map_container"} style={{ height: "180px" }}>
									{PlottedRadiusMap ? <PlottedRadiusMap
										containerElement={
											<div style={{ height: `100%` }} />
										}
										mapElement={
											<div style={{ height: `100%` }} />
										}
									/> : null}
								</Col>
								<Col xs="8" sm="8" md="8" lg="8" className="pt-20">
									<Row>
										<Col xs="6" sm="6" md="6" lg="6" className="no-padding-left text-black"><strong style={{color:"black"}}>Total Count</strong></Col>
										<Col xs="6" sm="6" md="6" lg="6" className="text-right no-padding-right text-black"><strong style={{color:"black"}}>{splitNumber(audienceCount.total+'')()}</strong></Col>
									</Row>
								</Col>
							</Row>
						</div>
					</div>
					doms.unshift(row)
				}
			}
			return (<div className="chart-view-container" style={{
				maxHeight: this.props && this.props.width > 1400 ? "480px" : "300px",
				overflowX: "hidden", overflowY: "auto"
			}}>{doms}</div>)
		} else {
			//const raw = JSON.parse(this.props.rawData)
			const locationRows = []
			const raw = JSON.parse(this.props.rawData)
			const locationDom = <div className="panel-flat " style={{ color: "#777" }}>
				<div className="panel-body no-padding-top  no-padding-bottom " style={{ paddingRight: "3em", borderColor: "#E3E3D3" }}>
					{locationRows}
				</div>
			</div>
			return (
				[locationRows.length > 0 ? locationDom : null,
				<div key="select_attrs_container" >
					<SelectedAttrs
						selectedAttrs={raw.selected_segments}
						plottedRadius={raw.plotted_values}
						selected_state={raw.selected_state}
						selected_city={raw.selected_city}
						selected_county={raw.selected_county}
						selected_dma={raw.selected_dma}
						categories={this.props.demoAttributes}
						zipcode={raw.zipcode}
						width={this.props.width}
						listMode={true}
					/></div>
				]
			)
		}
	}

	changeReportView(type) {
		this.setState({
			viewMode: type
		})
	}

	render() {
		const { data } = this.props

		return (
			<div id="segment-attrs-container" style={{ width: '90%', padding: '0', margin: '0 auto' }}>
				<Row className="pl-10 pr-20 no-padding-bottom no-margin-bottom pt-5">
					<Col xs="6" sm="6" md="6" lg="6" style={{ paddingLeft: "2em" }}>
						ATTRIBUTE
					</Col>
					<Col xs="6" sm="6" md="6" lg="6" className="text-right" style={{ paddingRight: "3em" }}>
						COUNT
					</Col>
				</Row>
				<hr className="mt-5 mb-10" />
				<FullRow className="no-padding-bottom no-padding-top no-padding-right" style={{marginBottom: '2em'}}>
					<Col xs="6" sm="6" md="6" lg="6">
						&nbsp;
					</Col>
					<Col xs="6" sm="6" md="6" lg="6" className="text-right" style={{paddingRight: "3em"}} >
						{this.state.viewMode === "chart" ? <i className={this.state.viewMode === 'chart' ? 'icon-pie-chart4 text-teal-400 font-15em active' : 'icon-pie-chart4 text-teal-400 font-15em'}>&nbsp;</i> :
							<a onClick={this.changeReportView.bind(this, "chart")}>
								<i className="icon-pie-chart4 text-grey font-15em">&nbsp;</i></a>
						}
						{this.state.viewMode === "list" ? <i className={this.state.viewMode === 'list' ? 'icon-menu6 text-teal-400 font-15em active' : 'icon-menu6 text-teal-400 font-15em'}>&nbsp;</i> :
							<a onClick={this.changeReportView.bind(this, "list")}>
								<i className="icon-menu6 text-grey font-15em">&nbsp;</i></a>
						}
					</Col>
				</FullRow>
				{this.getContent(data)}
			</div>
		)
	}
}
SegmentAttribute.propTypes = {
	data: PropTypes.object.isRequired,
	rawData: PropTypes.string.isRequired
}
export default SegmentAttribute


// WEBPACK FOOTER //
// ./src/components/Segment/Detail/SegmentAttribute.jsx